

























import Vue from 'vue'
import gift from '@/assets/svg/rounded/gift.svg?inline'
import paymentCard from '@/assets/svg/rounded/payment-card.svg?inline'
import caretDown from '@/assets/svg/rounded/caret-down.svg?inline'

interface Data {
  selectItems: string[]
  isOpen: boolean
}

interface Props {
  payMethod: string
}

interface Computed {
  model: string
}

export default Vue.extend<Data, {}, Computed, Props>({
  components: {
    gift,
    paymentCard,
    caretDown,
  },
  props: {
    payMethod: {
      required: true,
    },
  },
  data() {
    return {
      selectItems: ['tinkoff'],
      isOpen: false,
    }
  },
  computed: {
    model: {
      get() {
        return this.payMethod
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
})
